export const ROOT_PATH = '/life-insurance';
export const APPLICATION_PATH = 'application';
export const APPLICATION_IN_PROGRESS_PATH = 'application-in-progress';
export const PERMANENT_POLICY_APPLICATION_PATH = 'permanent-policy-application';
export const QUOTE_FINDER_PATH = 'quotes';
export const PARTNERS_PATH = 'partners';
export const ESTIMATES_PATH = 'estimates';
export const START_PATH = 'start';
export const MOTIVATIONS_PATH = 'motivations';

export const START_FULL_PATH = `${ROOT_PATH}/${START_PATH}`;

// Basics Routes
export const BASICS_PATH = 'basics';
export const INFO_PATH = 'info';
export const HOUSEHOLD_PATH = 'household';
export const SPOUSAL_PATH = 'sp'; // MLD-1 - Remove if Life Spousal Self Serve loses

export const BASICS_BASE_PATH = `${ROOT_PATH}/${BASICS_PATH}`;

// Full paths for /basics routes
export const INFO_FULL_PATH = `${BASICS_BASE_PATH}/${INFO_PATH}`;
export const HOUSEHOLD_FULL_PATH = `${BASICS_BASE_PATH}/${HOUSEHOLD_PATH}`;
export const SPOUSAL_FULL_PATH = `${BASICS_BASE_PATH}/${SPOUSAL_PATH}`;

// Health Profile Routes
export const HEALTH_PATH = 'health';
export const HEALTH_PROFILE_PATH = 'health_profile';
export const MEDICAL_CONDITIONS_PATH = 'conditions';
export const ASTHMA_PROFILE_PATH = 'asthma_profile';
export const CANCER_PROFILE_PATH = 'cancer_profile';
export const DEPRESSION_PROFILE_PATH = 'depression_profile';
export const DIABETES_PROFILE_PATH = 'diabetes_profile';
export const HEART_ATTACK_PROFILE_PATH = 'heart_attack_profile';
export const SLEEP_APNEA_PROFILE_PATH = 'sleep_apnea_profile';
export const STROKE_PROFILE_PATH = 'stroke_profile';
export const TOBACCO_PROFILE_PATH = 'tobacco_profile';
export const HEALTH_LIFESTYLE_PATH = 'health-lifestyle';

export const HEALTH_PROFILE_BASE_PATH = `${ROOT_PATH}/${HEALTH_PATH}`;

// Full paths for /health routes
export const ASTHMA_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${ASTHMA_PROFILE_PATH}`;
export const CANCER_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CANCER_PROFILE_PATH}`;
export const DEPRESSION_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${DEPRESSION_PROFILE_PATH}`;
export const DIABETES_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${DIABETES_PROFILE_PATH}`;
export const HEALTH_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEALTH_PROFILE_PATH}`;
export const HEART_ATTACK_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEART_ATTACK_PROFILE_PATH}`;
export const SLEEP_APNEA_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${SLEEP_APNEA_PROFILE_PATH}`;
export const STROKE_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${STROKE_PROFILE_PATH}`;
export const TOBACCO_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${TOBACCO_PROFILE_PATH}`;
export const HEALTH_LIFESTYLE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEALTH_LIFESTYLE_PATH}`;

// Full path for motivations route
export const MOTIVATIONS_FULL_PATH = `${ROOT_PATH}/${MOTIVATIONS_PATH}`;

// Full path for partners route
export const PARTNERS_FULL_PATH = `${ROOT_PATH}/${PARTNERS_PATH}`;

// Full path for Estimates route
export const ESTIMATES_FULL_PATH = `${ROOT_PATH}/${ESTIMATES_PATH}`;

// Full paths for application routes
export const APPLICATION_FULL_PATH = `${ROOT_PATH}/${APPLICATION_PATH}`;
export const APPLICATION_IN_PROGRESS_FULL_PATH = `${ROOT_PATH}/${APPLICATION_IN_PROGRESS_PATH}`;
export const PERMANENT_POLICY_APPLICATION_FULL_PATH = `${ROOT_PATH}/${PERMANENT_POLICY_APPLICATION_PATH}`;

export const DASHBOARD_LIFE_PATH = '/dashboard/life';
export const DASHBOARD_CONFIRMATION_PATH = '/dashboard/life/confirmation';

export const REDIRECT_EVENT = 'redirect';
export const APPLIED_POLICY_REDIRECT_REASON = 'Restricted AU Applied Policy';

// Quotes Routes
export const QUOTES_BASE_PATH = `${ROOT_PATH}/quotes`;
export const QUOTES_START_PATH = 'start';
// Carrier Quotes Routes
export const MY_QUOTES_FULL_PATH = `${ROOT_PATH}/my-quotes`;
export const MY_QUOTES_NEXT_STEPS_PATH = 'next-steps';
export const MY_QUOTES_NEXT_STEPS_FULL_PATH = `${MY_QUOTES_FULL_PATH}/${MY_QUOTES_NEXT_STEPS_PATH}`;

// Banner MVP Routes
export const BANNER_MVP_ADDRESS_PATH = 'address';
export const BANNER_MVP_DRIVER_LICENSE_PATH = 'driver-license';
export const BANNER_MVP_DRIVING_HISTORY_PATH = 'driving-history';
export const BANNER_MVP_ALCOHOL_HISTORY_PATH = 'alcohol-history';
export const BANNER_MVP_SOCIAL_SECURITY_PATH = 'social-security';
export const BANNER_MVP_EMPLOYMENT_PATH = 'employment';
export const BANNER_MVP_BIRTHPLACE_PATH = 'birthplace';
export const BANNER_MVP_POLICY_DETAILS_PATH = 'policy-details';
export const BANNER_MVP_APPLICATION_HISTORY_PATH = 'application-history';
export const BANNER_MVP_REVIEW_PATH = 'review';
export const BANNER_MVP_CARRIER_HANDOFF_PATH = 'carrier-handoff';

// Client-led Referrals - Remove if Client-led Referral PgPro experiment loses
export const OFFBOARD_CLIENT_LED_REFERRAL_FULL_PATH = `${ROOT_PATH}/advisor-next-steps`;

export const APPLY_FULL_PATH = `${ROOT_PATH}/apply`;

// CON-2524 - Remove if Coverage needs loses
// Full paths for coverage needs routes
export const COVERAGE_NEEDS_BASE_PATH = `${ROOT_PATH}/coverage-needs`;
export const COVERAGE_NEEDS_REDIRECT_REASON = 'Not bucketed in Coverage Needs experiment';

export const COVERAGE_NEEDS_START_PATH = 'start';
export const COVERAGE_NEEDS_INCOME_PATH = 'income';
export const COVERAGE_NEEDS_OBLIGATIONS_PATH = 'obligations';
export const COVERAGE_NEEDS_SAVINGS_PATH = 'savings';
export const COVERAGE_NEEDS_PARTNER_PATH = 'partner';
export const COVERAGE_NEEDS_CHILDREN_PATH = 'children';
export const COVERAGE_NEEDS_CALCULATING_PATH = 'calculating';
export const COVERAGE_NEEDS_RECOMMENDATION_PATH = 'recommendation';

export const COVERAGE_NEEDS_START_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_START_PATH}`;
export const COVERAGE_NEEDS_INCOME_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_INCOME_PATH}`;
export const COVERAGE_NEEDS_OBLIGATIONS_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_OBLIGATIONS_PATH}`;
export const COVERAGE_NEEDS_SAVINGS_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_SAVINGS_PATH}`;
export const COVERAGE_NEEDS_PARTNER_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_PARTNER_PATH}`;
export const COVERAGE_NEEDS_CHILDREN_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_CHILDREN_PATH}`;
export const COVERAGE_NEEDS_CALCULATING_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_CALCULATING_PATH}`;
export const COVERAGE_NEEDS_RECOMMENDATION_FULL_PATH = `${COVERAGE_NEEDS_BASE_PATH}/${COVERAGE_NEEDS_RECOMMENDATION_PATH}`;

// Common App routes - HOUSE-1425
export const COMMON_APP_PATH = 'common-app';
export const COMMON_APP_PERSONAL_DETAILS_PATH = 'personal-details';
export const COMMON_APP_HOUSEHOLD_INFORMATION_PATH = 'household-information';
export const COMMON_APP_RESIDENCE_PATH = 'residence';
export const COMMON_APP_FINANCIAL_INFORMATION_PATH = 'financial-information';
export const COMMON_APP_APPLICATION_DETAILS_PATH = 'application-details';
export const COMMON_APP_ADDITIONAL_COVERAGE_OPTIONS_PATH = 'additional-coverage-options';
export const COMMON_APP_BENEFICIARIES_PATH = 'beneficiaries';
export const COMMON_APP_INSURANCE_HISTORY_PATH = 'insurance-history';
export const COMMON_APP_EMPLOYMENT_PATH = 'employment';
export const COMMON_APP_REVIEW_PATH = 'review';

export const COMMON_APP_PERSONAL_DETAILS_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_PERSONAL_DETAILS_PATH}`;
export const COMMON_APP_HOUSEHOLD_INFORMATION_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_HOUSEHOLD_INFORMATION_PATH}`;
export const COMMON_APP_RESIDENCE_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_RESIDENCE_PATH}`;
export const COMMON_APP_FINANCIAL_INFORMATION_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_FINANCIAL_INFORMATION_PATH}`;
export const COMMON_APP_APPLICATION_DETAILS_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_APPLICATION_DETAILS_PATH}`;
export const COMMON_APP_ADDITIONAL_COVERAGE_OPTIONS_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_ADDITIONAL_COVERAGE_OPTIONS_PATH}`;
export const COMMON_APP_EMPLOYMENT_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_EMPLOYMENT_PATH}`;
export const COMMON_APP_BENEFICIARIES_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_BENEFICIARIES_PATH}`;
export const COMMON_APP_INSURANCE_HISTORY_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_INSURANCE_HISTORY_PATH}`;
export const COMMON_APP_REVIEW_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_REVIEW_PATH}`;

export const COMMON_APP_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}`;

// Continue Online (Underwriting) routes - LIFE-3103
export const CONTINUE_ONLINE_PATH = 'underwriting';
export const CONTINUE_ONLINE_FULL_PATH = `${ROOT_PATH}/${CONTINUE_ONLINE_PATH}`;
export const CONTINUE_ONLINE_HEALTH_INTRO_PATH = 'health-intro';
export const CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH = 'pregnancy-history';
export const CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH = 'blood-pressure';
export const CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH = 'cholesterol';
export const CONTINUE_ONLINE_ADD_ADHD_PATH = 'add-adhd';
export const CONTINUE_ONLINE_ANXIETY_PATH = 'anxiety';
export const CONTINUE_ONLINE_MARIJUANA_PATH = 'marijuana';
export const CONTINUE_ONLINE_ADVERSE_DRIVING_PATH = 'adverse-driving';
export const CONTINUE_ONLINE_SUBSTANCE_USE_PATH = 'substance-use';
export const CONTINUE_ONLINE_CITIZENSHIP_PATH = 'citizenship';
export const CONTINUE_ONLINE_CRIMINAL_HISTORY_PATH = 'criminal-history';
export const CONTINUE_ONLINE_MILITARY_SERVICE_PATH = 'military-service';
export const CONTINUE_ONLINE_HAZARDOUS_ACTIVITIES_PATH = 'hazardous-activities';
export const CONTINUE_ONLINE_FINANCES_PATH = 'finances';
export const CONTINUE_ONLINE_TRAVEL_PATH = 'travel';
export const CONTINUE_ONLINE_FAMILY_HISTORY_PATH = 'family-history'; // LIFE-3171 - move to Health section and rename if Underwriting Funnel Remix experiment wins
export const HEALTH_LIFESTYLE_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEALTH_LIFESTYLE_PATH}`;
export const MEDICAL_CONDITIONS_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${MEDICAL_CONDITIONS_PATH}`;
export const BLOOD_PRESSURE_DETAILS_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH}`;
export const CHOLESTEROL_DETAILS_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH}`;
export const ADD_ADHD_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_ADD_ADHD_PATH}`;
export const ANXIETY_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_ANXIETY_PATH}`;
export const PREGNANCY_HISTORY_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH}`;
export const FAMILY_HISTORY_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_FAMILY_HISTORY_PATH}`;

// Full path for partners route
export const LIFESTYLE_PATH = 'lifestyle';
export const LIFESTYLE_FULL_PATH = `${ROOT_PATH}/${LIFESTYLE_PATH}`;
